import React, { ReactElement } from "react"
import styled from "styled-components"
import { AvatarGroup as MaterialAvatarGroup } from "@mui/material"
import { Avatar, AvatarSize } from "../atoms/avatar"
import { Profile } from "./profile"
import { theme } from "../../theme"

export type AvatarGroupProps = {
  size?: AvatarSize
  max?: number
  dataCy?: string
  children?: Array<ReactElement>
}

export const AvatarGroup = (props: AvatarGroupProps) => {
  const { size = AvatarSize.medium, max = 4, dataCy, children } = props

  let extraAvatars = 0

  if (children) {
    extraAvatars = children?.length > max ? children?.length - max + 1 : 0
  }

  function notEmpty<TValue>(value: TValue | null | undefined): value is TValue {
    return value !== null && value !== undefined
  }

  const extraInfo = (
    <React.Fragment>
      {children
        ?.slice(-1 * extraAvatars)
        .filter((child) => notEmpty<ReactElement>(child))
        .map((child, index) => {
          return (
            <Extra key={index}>
              <Profile
                individual={child.props.individual}
                starred={child.props.starred}
                identity={child.props.identity}
              />
            </Extra>
          )
        })}
    </React.Fragment>
  )

  return (
    <AvatarGroupStyle max={max} data-cy={dataCy}>
      {children?.slice(0, children?.length - extraAvatars).map((child, index: number) => {
        return React.cloneElement(child, {
          ...child.props,
          size,
          style: {
            zIndex: children.length - index,
            boxSizing: "content-box",
            border:
              child.props.hasColor === false ? `2px solid ${theme.color.white1}` : `2px solid ${theme.color.white}`,
            marginLeft: index > 0 ? "-6px" : "0",
          },
        })
      })}
      {extraAvatars > 0 ? (
        <ExtraAvatar customContent={`+${extraAvatars}`} individual={{}} size={size} extraInfo={extraInfo} />
      ) : null}
    </AvatarGroupStyle>
  )
}

const Extra = styled.div`
  width: 220px;
`

const AvatarGroupStyle = styled(MaterialAvatarGroup)`
  & > .MuiAvatar-colorDefault {
    border: 2px solid ${theme.color.white};
  }

  .MuiAvatarGroup-avatar {
    border: 2px solid ${theme.color.white};
  }
`

const ExtraAvatar = styled(Avatar)`
  && {
    border: 2px solid ${theme.color.grey2};
    background: none;
    margin-top: ${theme.spacing.xs};
    margin-left: -6px;
    box-sizing: border-box;
  }
`
